module.exports = __webpack_public_path__ + "static/pkolo_logo-d334805f3c2e8a8721fc8ff4b3f9af2a.svg";